// Firebase configuration and initialization
// DO NOT commit actual API keys to git - use environment variables in production

import { initializeApp } from 'firebase/app';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';

// Your web app's Firebase configuration
// For production, use environment variables (REACT_APP_*)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "optibillanalytics.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "optibillanalytics",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "optibillanalytics.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "YOUR_MESSAGING_SENDER_ID",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "YOUR_APP_ID"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Functions
const functions = getFunctions(app);

// Connect to Functions Emulator in development
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

// Export functions instance and callable functions
export { functions };

// Helper function to call Cloud Functions
export const callFunction = (functionName, data) => {
  const callable = httpsCallable(functions, functionName);
  return callable(data);
};

// Contact form email function
export const sendContactEmail = async (formData) => {
  try {
    const response = await fetch(
      `https://us-central1-${firebaseConfig.projectId}.cloudfunctions.net/sendContactEmail`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      }
    );

    const result = await response.json();
    
    if (!response.ok) {
      throw new Error(result.message || 'Failed to send email');
    }

    return result;
  } catch (error) {
    console.error('Error calling Cloud Function:', error);
    throw error;
  }
};
